export enum Headers {
  Authorization = 'Authorization',
  workspaceId = 'X-WORKSPACE-ID',
  accept = 'accept',
}
